import { Params, generatePath as routerGeneratePath } from 'react-router-dom';

export enum RAW_ROUTES {
  SharedPublicMeeting = '/meetings/shared/p/',
  SharedMeeting = '/meetings/shared/',
  Meeting = '/meeting/',
  Chat = '/chat/'
}

export const QUICK_ACTIONS_ROUTE = 'quick-actions';

enum RoutesMap {
  Home = '/',
  Login = '/login',
  SignUp = '/auth/sign-up',
  LoginUserDetails = 'details',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
  Goals = '/goals',
  Tasks = '/tasks',
  Calendar = '/calendar',
  CompanyProfile = '/company-profile',
  PersonalSettings = '/personal-settings',
  Integrations = '/integrations',
  CalendarMeeting = '/calendar/meeting/:meetingId',
  Meeting = '/meeting/:meetingId',
  GoogleAuth = '/auth/google',
  MicrosoftAuth = '/auth/microsoft',
  HubspotAuth = '/auth/hubspot',
  SlackAuth = '/auth/slack',
  GoogleDriveAuth = '/auth/google-drive',
  SharedMeeting = '/meetings/shared/:sharedMeetingId',
  SharedPublicMeeting = '/meetings/shared/p/:sharedMeetingId',
  MeetingHub = '/meeting-hub',
  MeetingHubMeeting = '/meeting-hub/meeting/:meetingId',
  JamiesCapabilities = '/jamies-capabilities',
  MobileInviteBot = '/mobile-invite-bot',
  Chat = '/chat/:threadId',
  QuickActions = `/chat/${QUICK_ACTIONS_ROUTE}`
}

export const generatePath = (path: string, params?: Params) =>
  routerGeneratePath(path, { '*': '', ...params });

export const toMeeting = (meetingId: string) => generatePath(RoutesMap.Meeting, { meetingId });

export default RoutesMap;
